import { useSpring, animated } from '@react-spring/web';
import CommentHeader from "./CommentHeader";

export default function CommentContent({comment}){

	const [style, api] = useSpring(
    () => ({
			from: { opacity: 0, transform: 'translateY(50px) scale(0.8)' },
			to: { opacity: 1, transform: 'translateY(0px) scale(1)' },
		}),
    []
  )

	return (
		<animated.div
			class='comment--content'
			style={style}
		>
			<CommentHeader id={comment.id} author={comment.author} approved={comment.approved} />
			<div className='comments--body' dangerouslySetInnerHTML={{ __html: comment.content }}></div>
		</animated.div>
	)
}